import { UserDetailsPage } from '@/app/users/UserDetailsPage';
import { UsersListPage } from '@/app/users/UsersListPage';
import { Route, Routes } from 'react-router-dom';

export const UsersRoutes = () => (
    <Routes>
        <Route index element={<UsersListPage />} />
        <Route path=":userId/*" element={<UserDetailsPage />} />
    </Routes>
);
